import { render, staticRenderFns } from "./HomeReportingChannelKpisCard.vue?vue&type=template&id=9738e4a4&scoped=true&"
import script from "./HomeReportingChannelKpisCard.vue?vue&type=script&lang=js&"
export * from "./HomeReportingChannelKpisCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeReportingChannelKpisCard.vue?vue&type=style&index=0&id=9738e4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9738e4a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9738e4a4')) {
      api.createRecord('9738e4a4', component.options)
    } else {
      api.reload('9738e4a4', component.options)
    }
    module.hot.accept("./HomeReportingChannelKpisCard.vue?vue&type=template&id=9738e4a4&scoped=true&", function () {
      api.rerender('9738e4a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/home/HomeReportingChannelKpisCard.vue"
export default component.exports